{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Вижте всички опции",
  "Spoiler_Reveal_Tooltip": "Кликнете, за да разкриете",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Туитнете това",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Елементът е свит",
  "Spoiler_Reveal_Video_CTA": "Разкриване на видеото",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Разширете изображението",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Вижте всички резултати",
  "Spoiler_Reveal_Image_Placeholder": "Това изображение съдържа спойлер",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Търсете плъзгач",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Можете да гласувате за повече от един отговор.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Показване на повече аудиоконтроли",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Затвори",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Зареждане на {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Прочетете повече",
  "Spoiler_Insert_Tooltip": "Спойлер",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Звук",
  "Spoiler_Reveal_Gallery_Placeholder": "Тази галерия съдържа спойлер",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Резервирайте сега",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Отмяна на заглушаване",
  "Spoiler_Reveal_Gallery_CTA": "Разкриване на галерията",
  "Poll_Viewer_ShowLess_CTA": "Покажи по-малко",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Заглушаване",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} анонимен",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Последвайте",
  "VerticalEmbed_Products_Button": "Купете сега",
  "Poll_Viewer_Toast_Error_ServerDown": "Не можа да се свърже със сървъра. Опитайте отново по-късно.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} човек гласува за този отговор",
  "Poll_Viewer_VoteCount": "{{number}} гласа",
  "VerticalEmbed_Events_Button": "Регистрирайте се сега",
  "Spoiler_Reveal_Image_CTA": "Разкриване на изображението",
  "Poll_Viewer_Toast_Error_Connection": "Няма интернет. Проверете връзката си.",
  "Poll_Viewer_Visibility_Owner_Footer": "Само вие можете да видите резултатите.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} души гласуваха за този отговор",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Елементът е разширен",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Това видео съдържа спойлер",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Вижте пълната публикация",
  "UploadFile_Viewer_Download": "Изтегляне на {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}ч.",
  "VerticalEmbed_Units_Minute": "{{minutes}}мин.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
